var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    class: {
      'nav-muted': !_vm.search
    }
  }, [_c('div', {
    staticClass: "inp-text inp-search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    attrs: {
      "type": "text",
      "placeholder": 'Search through ' + _vm.$root.fragmentCount + ' fragments...'
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "nav-fragments"
  }, [(!_vm.search || !_vm.list) ? _c('div', {
    staticClass: "a-recent"
  }, [_c('a', {
    staticClass: "a-fragment",
    attrs: {
      "href": '#!create'
    },
    on: {
      "mouseenter": _vm.leave,
      "mouseleave": _vm.leave
    }
  }, [_vm._v("\n        Add...\n        "), _c('small', [_vm._v("new fragment")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.limitedList), function(fragment) {
    return (!fragment['@temp']) ? _c('div', {
      staticClass: "a-recent"
    }, [_c('a', {
      staticClass: "a-fragment",
      attrs: {
        "href": '#!' + fragment['@id']
      },
      on: {
        "mouseenter": function($event) {
          _vm.enter(fragment['@id'])
        },
        "mouseleave": _vm.leave
      }
    }, [_vm._v("\n        " + _vm._s(fragment['schema:name'] || _vm.label(fragment) || fragment['dcterms:title'] || fragment['@id']) + "\n        "), (fragment['schema:name'] || _vm.label(fragment) || fragment['dcterms:title']) ? _c('small', [_vm._v(_vm._s(_vm.rellipsis(fragment['@id'])))]) : _vm._e()])]) : _vm._e()
  })], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3eeace99","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RecentFragments.vue
// module id = 107
// module chunks = 1